// Translations
import error from 'pages/error/translations/de'
import login from 'pages/login/translations/de'
import passwordChange from 'pages/password-change/translations/de'
import register from 'pages/register/translations/de'
import reset from 'pages/reset/translations/de'
import termsOfService from 'pages/terms-of-service/translations/de'
import twoFactorAuthentication from 'pages/two-factor-authentication/translations/de'
import verification from 'pages/verification/translations/de'

// Translation: German > Pages
const pages = Object.freeze({
	error,
	login,
	passwordChange,
	register,
	reset,
	termsOfService,
	twoFactorAuthentication,
	verification
})

// Export
export default pages
